/**
 *  Created by pw on 2019-09-19 20:54.
 */
import { visit } from '@ekuaibao/helpers';
export function getDepartmentsData(items) {
    if (items === void 0) { items = []; }
    var originItems = items;
    try {
        originItems = JSON.parse(JSON.stringify(items));
    }
    catch (e) { }
    if (!items.length) {
        return { data: items, mapData: {}, noRootPathMap: {}, list: [], enPathMap: {}, noRootEnPathMap: {} };
    }
    var _a = mapDataFn(items), mapData = _a.mapData, pathMap = _a.pathMap, list = _a.list, noRootPathMap = _a.noRootPathMap, enPathMap = _a.enPathMap, noRootEnPathMap = _a.noRootEnPathMap;
    return { data: originItems, mapData: mapData, pathMap: pathMap, list: list, noRootPathMap: noRootPathMap, enPathMap: enPathMap, noRootEnPathMap: noRootEnPathMap };
}
export function departmentMap(items) {
    var mapData = {};
    visit(items, function (node) {
        mapData[node.id] = node;
    });
    return mapData;
}
function mapDataFn(items) {
    if (items === void 0) { items = []; }
    var mapData = {};
    var noRootPathMap = {};
    var noRootEnPathMap = {};
    var pathMap = {};
    var enPathMap = {};
    var list = [];
    visit(items, function (node) {
        mapData[node.id] = node;
        list.push(node);
        var enName = getEnName(node);
        if (node.parentId && node.parentId.length) {
            var parentPath = pathMap[node.parentId] || '';
            var parentEnPath = enPathMap[node.parentId] || '';
            var noRootParentPath = noRootPathMap[node.parentId] || '';
            var noRootParentEnPath = noRootEnPathMap[node.parentId] || '';
            pathMap[node.id] = parentPath.length ? parentPath + "/" + node.name : node.name;
            enPathMap[node.id] = parentEnPath.length ? parentEnPath + "/" + enName : enName;
            noRootPathMap[node.id] = noRootParentPath.length ? noRootParentPath + "/" + node.name : node.name;
            noRootEnPathMap[node.id] = noRootParentEnPath.length ? noRootParentEnPath + "/" + enName : enName;
        }
        else {
            pathMap[node.id] = node.name;
            enPathMap[node.id] = enName;
        }
    });
    return { mapData: mapData, pathMap: pathMap, list: list, noRootPathMap: noRootPathMap, enPathMap: enPathMap, noRootEnPathMap: noRootEnPathMap };
}
var getEnName = function (item) {
    return item.enName || item.name;
};
